// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.26670e9a.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"2793":"a44659e1","2805":"32c410ba","8577":"46657d27","8703":"b0c8a2ae","8720":"86a9b17a"}[chunkId] + ".chunk.css";
};